var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"loading":_vm.loading,"hide-footer":"","title":"Selecione o local"}},[_c('Form',{attrs:{"fila":_vm.fila,"salas":_vm.salas,"tela":_vm.tela},on:{"stored":_vm.handleExit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }